import axios from 'axios'

import { Notification } from 'element-ui'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// request interceptor
service.interceptors.request.use(config => {
  return config
}, error => {
  Notification({
    message: '网络错误，请稍后再试' || 'Error',
    type: 'error',
    duration: 5 * 1000
  })
  // console.log(error)
  return Promise.reject(error)
})


// response interceptor
service.interceptors.response.use(response => {
  const res = response.data
  //todo
  if(res.success) {
    return res.returnValue || res.data
  } else {
    // return result error
    return Promise.reject(res)
  }
}, error => {
  errorHandle()
  Notification({
    message: '网络错误，请稍后再试' || 'Error',
    type: 'error',
    duration: 5 * 1000
  })
  // console.log(error)
  return Promise.reject(error)
})

export default service